import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface CameraPictoProps extends pictoProps {
}

export interface CameraPictoState extends pictoState {
}

export class CameraPicto extends Picto<CameraPictoProps,CameraPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.cameraPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(CameraPicto);
